import { sendErrorToServices } from 'lib/logging';
import { useEffect, useRef } from 'react';

const BANDWIDTH_THRESHOLD = 1000000; // 1 Mbps
const CHECK_INTERVAL = 10000; // 10 seconds

export function useBandwidthManagement(player: HTMLVideoElement | null) {
  const lastBandwidth = useRef<number>(0);

  useEffect(() => {
    if (!player) return;

    // Access HLS.js instance from video element
    const hls = (player as any).hlsPlayer;
    if (!hls) return;

    const checkBandwidth = () => {
      const currentBandwidth = hls.bandwidthEstimate;

      // Check for significant bandwidth drops
      if (
        lastBandwidth.current > 0 &&
        currentBandwidth < lastBandwidth.current * 0.5 &&
        currentBandwidth < BANDWIDTH_THRESHOLD
      ) {
        sendErrorToServices('Bandwidth Warning', {
          previousBandwidth: lastBandwidth.current,
          currentBandwidth,
          currentLevel: hls.currentLevel
        });

        // Force a quality level switch if needed
        if (hls.currentLevel > 0) {
          hls.currentLevel = hls.currentLevel - 1;
        }
      }

      lastBandwidth.current = currentBandwidth;
    };

    const intervalId = setInterval(checkBandwidth, CHECK_INTERVAL);

    return () => {
      clearInterval(intervalId);
    };
  }, [player]);
}
